export function Column({ children, ...props }) {
    return (
        <div {...props}>
            {children}
        </div>
    );
}
